/**
 * @generated SignedSource<<53a82c4d5f6d4a903b628178ddbe9e81>>
 * @relayHash 4434db08f18656b277e4683bc4dcaf5d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 049c6ec4db12d273730e8108ab3e3697ea427432281cceb660f908b10068087b

import type { ConcreteRequest } from 'relay-runtime';
export type useIsSiteAdminUseIsSiteAdminQuery$variables = Record<PropertyKey, never>;
export type useIsSiteAdminUseIsSiteAdminQuery$data = {
  readonly isSiteAdmin: boolean | null;
};
export type useIsSiteAdminUseIsSiteAdminQuery = {
  response: useIsSiteAdminUseIsSiteAdminQuery$data;
  variables: useIsSiteAdminUseIsSiteAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "isSiteAdmin"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsSiteAdminUseIsSiteAdminQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsSiteAdminUseIsSiteAdminQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4434db08f18656b277e4683bc4dcaf5d",
    "id": "049c6ec4db12d273730e8108ab3e3697ea427432281cceb660f908b10068087b",
    "metadata": {},
    "name": "useIsSiteAdminUseIsSiteAdminQuery",
    "operationKind": "query",
    "text": "query useIsSiteAdminUseIsSiteAdminQuery{isSiteAdmin}"
  }
};
})();

(node as any).hash = "ce32420547b7702bc996599bbe635142";

export default node;
